export enum Screen {
	Welcome = "welcome",
	Overview = "overview",
	SwitchSite = "switchSite",
	EditNotes = "editNotes",
	Success = "success",
}
